import { useEffect, useState } from "react";
import { formatCountdown, formatDropTime } from "../../shared/i18n/index.ts";
import { serverNow } from "../lib/clock.ts";
import { useI18n } from "../lib/i18n.tsx";

/** "Drop tiếp theo · T7 20:00 · 2n 03g 12p · 47 món đang chờ" (08-design.md §Home). */
export function DropCountdown({ next, queued }: { next: number; queued: number }) {
  const { t, locale } = useI18n();
  const [now, setNow] = useState(serverNow);
  useEffect(() => {
    const id = setInterval(() => setNow(serverNow()), 1000);
    return () => clearInterval(id);
  }, []);
  return (
    <section className="dropblock" data-testid="drop-block">
      <div className="dropblock__label">
        {t("drop.next", { when: formatDropTime(next, locale, now) })}
      </div>
      <div className="dropblock__count">{formatCountdown(next - now, locale)}</div>
      <div className="muted small">{t("drop.queued", { n: queued })}</div>
    </section>
  );
}
